export interface RcaInsuranceCompany {
    id: number;
    code: string;
    name: string;
}


export interface RcaForm {
    availability: Array<number> | number | null;
    valid_from: string | null;
    gdpr_agreement: boolean | null;
    consultancy_waiver: boolean | null;
}

export const createDefaultRcaForm = (): RcaForm => {
    return {
        availability: [6, 12],
        valid_from: null,
        gdpr_agreement: false,
        consultancy_waiver: false,
    }
}

export interface RcaDanubiusForm extends RcaForm {
    no_assistance_agreement: boolean | null;
    notification_agreement: boolean | null;
}

export const createDefaultRcaDanubiusForm = (): RcaDanubiusForm => {
    return {
        availability: [6, 12],
        valid_from: null,
        gdpr_agreement: false,
        no_assistance_agreement: false,
        notification_agreement: false,
        consultancy_waiver: false,
    }
}

export interface RcaAvailability {
    id: number;
    name: string;
}

export interface OfferForm {
    is_deducted: boolean | null;
    insurance_company: RcaInsuranceCompany | null;
}

export const createDefaultOfferForm = (): OfferForm => {
    return {
        is_deducted: false,
        insurance_company: null,
    }
}

export interface ApiOffer {
    response_body: {
        error: boolean;
        [key: string]: any;
    };
    [key: string]: any;
}

export interface ApiOfferSubArray {
    [key: number]: ApiOffer;
    [key: string]: any;
}


export interface RcaFormValidation {
    availability: boolean;
    valid_from: boolean;
    gdpr_agreement: boolean;
    [key: string]: boolean | boolean[]; // Add index signature
}

export const createDefaultRcaFormValidation = (): RcaFormValidation => {
    return {
        availability: true,
        valid_from: true,
        gdpr_agreement: false,
    }
}

export interface RcaDanubiusFormValidation extends RcaFormValidation {
    no_assistance_agreement: boolean;
    notification_agreement: boolean;
    [key: string]: boolean | boolean[]; // Add index signature
}

export const createDefaultRcaDanubiusFormValidation = (): RcaDanubiusFormValidation => {
    return {
        availability: true,
        valid_from: true,
        gdpr_agreement: false,
        no_assistance_agreement: false,
        notification_agreement: false,
    }
}

export interface RcaPolicy {
    id: number;
    amount: string;
    auction_code: string;
    ws_offer_code: string;
    series: string;
    number: string;
    commission_value: string;
    valid_from: string;
    valid_until: string;
    green_card_excluded: string;
    is_deducted: boolean;
    is_sent: number;
    commission_percentage: number;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    rca_offer_id: number;
    rca_insurance_company_id: number;
    rca_availability_id: number;
    vehicle_id: number;
    user_id: number;
    order_id: number;
    code: string | null;
    email: string | null;
    error_message: string;
}